var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.iframeUrl)?_c('div',{staticClass:"post-campaign-report"},[_c('iframe',{staticClass:"w-100 h-100",staticStyle:{"border":"0"},attrs:{"width":"800","height":"1000","src":_vm.iframeUrl,"frameborder":"0","allowfullscreen":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }